import React, { useState } from "react";
import axios from "axios";

import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { useGetDealersQuery } from "../../../features/api/dealerApi";

import headerLogo from "../../../asset/johura_logo.png";

import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import { PDFViewer } from "@react-pdf/renderer";
import { API_BASE_URL } from "../../../components/baseUrl";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "white",
    paddingBottom: "88pt",
  },
  header: {
    color: "white",
    marginBottom: 5,
    textAlign: "center",
    height: "3.8cm",
  },
  imgborder: {
    borderBottom: "1px solid green",
    paddingBottom: "5px",
    marginBottom: "3px",
  },
  HedingTextBorder: {
    borderBottom: "1px solid red",
  },

  invMain: {
    textAlign: "center",
    fontSize: "12px",
    paddingBottom: "6px",
  },
  invoice: {
    padding: "10px 20px",
    fontSize: "10px",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  invLeft: {
    fontWeight: "bold",
    flexDirection: "column",
    gap: "4px",
    fontSize: "12px",
  },
  invRight: {
    fontSize: "12px",
  },
  invBottom: {
    fontSize: "11px",
    padding: "0 20 10 20",
    flexDirection: "column",
    gap: "8px",
  },
  footer: {
    color: "white",
    height: "2cm",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    marginTop: 20,
    textAlign: "center",
    flexDirection: "row",
    justifyContent: "center",
    fontSize: "12",
  },
  footerAddr: {
    height: "",
    color: "black",
    fontSize: "8px",
    margin: "13 auto",
    width: "100%",
    fontWeight: "thin",
  },
  footerBgc: {
    backgroundColor: "#006600",
    height: "0.8cm",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
  table: {
    borderWidth: 1,
    marginHorizontal: 20,
    borderColor: "#D0D0D0",
    fontSize: "11",
    flexFlow: 1,
  },
  tableHeaderBg: {
    backgroundColor: "#aaa",
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCell: {
    borderBottomWidth: 1,
    borderRight: 1,
    borderColor: "#D0D0D0",
    textAlign: "center",
    padding: 6,
  },
  tableCellTitle: {
    marginBottom: 4,
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
  },
  author: {
    fontSize: "10px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "50px",
    padding: "0 20px",
  },
  authorText: {
    borderTop: "1px solid black",
    paddingTop: "1px",
  },
  pageNumber: {
    position: "absolute",
    bottom: 55,
    right: 20,
    fontSize: 10,
  },
});

const CollectionReports = () => {
  const [visible, setVisible] = useState(true);
  const { data } = useGetDealersQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const dealers = data?.dealer;

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  let getSDay = startDate.getDate();
  let getSMonth = startDate.getMonth() + 1;
  let getSYear = startDate.getFullYear();
  let getStartDate = getSYear + "-" + getSMonth + "-" + getSDay;

  let getEDay = endDate.getDate();
  let getEMonth = endDate.getMonth() + 1;
  let getEYear = endDate.getFullYear();
  let getEndDate = getEYear + "-" + getEMonth + "-" + getEDay;

  const sDate = new Date(startDate);
  let sDay = sDate.getDate();
  let sMonth = sDate.getMonth() + 1;
  let sYear = sDate.getFullYear();
  let sGetDate = sDay + "-" + sMonth + "-" + sYear;

  const eDate = new Date(endDate);
  let eDay = eDate.getDate();
  let eMonth = eDate.getMonth() + 1;
  let eYear = eDate.getFullYear();
  let eGetDate = eDay + "-" + eMonth + "-" + eYear;

  const [dateTranaction, setDateTransaction] = useState([]);
  const mrItems = dateTranaction?.filter((item) =>
    item?.invoice_id?.startsWith("MR")
  );
  const subTotal = mrItems?.reduce(
    (sum, total) => sum + total?.credit_amount,
    0
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/transactionDate?startDate=${getStartDate}&endDate=${getEndDate}`
      );

      if (response) {
        setDateTransaction(response?.data?.MR);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // function for formated date
  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }

  const user = JSON.parse(localStorage.getItem("user"));
  return (
    <div className="w-full max-w-[1280px] mx-auto px-6 md:px-auto h-[90vh] overflow-auto">
      <div>
        <h1 className="font-bold text-xl my-4">Client Collection Reports</h1>
        <div className="bg-white shadow p-4 flex items-center justify-between">
          <form onSubmit={handleSubmit} className="flex items-center gap-10">
            <div>
              <label className="font-bold">Start Date: </label>
              <DateTimePicker
                value={startDate}
                onChange={setStartDate}
                className="border w-full pl-1 mt-1"
              />
            </div>
            <div>
              <label className="font-bold">End Date: </label>
              <DateTimePicker
                value={endDate}
                onChange={setEndDate}
                className="border w-full pl-1 mt-1"
              />
            </div>
            <input
              type="submit"
              value="View"
              className="bg-indigo-500 text-white font-bold px-2 rounded mt-6 py-1 cursor-pointer"
            />
          </form>
        </div>
      </div>

      {mrItems?.length > 0 && (
        <div>
          <input
            onClick={() => setVisible(!visible)}
            type="checkbox"
            defaultChecked
            className="cursor-pointer"
          />
          <PDFViewer style={{ width: "100%", height: "100vh" }}>
            <Document>
              <Page size="A4" style={styles.page}>
                {/* Header */}
                <View style={styles.header} fixed>
                  {visible && (
                    <View>
                      <View style={styles.imgborder}>
                        <Image src={headerLogo} />
                      </View>
                      <Text style={styles.HedingTextBorder}></Text>
                    </View>
                  )}
                </View>

                {/* Invoice */}
                <View style={styles.invMain}>
                  <Text>
                    Collection Report - Date: {sGetDate} to {eGetDate}
                  </Text>
                </View>

                {/* Table */}
                <View style={styles.table}>
                  {/* Table Header */}
                  <View
                    style={{ ...styles.tableRow, ...styles.tableHeaderBg }}
                    fixed
                  >
                    <View style={{ ...styles.tableCell, width: "8%" }}>
                      <Text>Sl No.</Text>
                    </View>
                    <View style={{ ...styles.tableCell, width: "11%" }}>
                      <Text>MR No.</Text>
                    </View>
                    <View style={{ ...styles.tableCell, width: "15%" }}>
                      <Text>MR Date</Text>
                    </View>
                    <View style={{ ...styles.tableCell, width: "25%" }}>
                      <Text>Client</Text>
                    </View>
                    <View style={{ ...styles.tableCell, width: "28%" }}>
                      <Text>Particular</Text>
                    </View>
                    <View
                      style={{
                        ...styles.tableCell,
                        width: "13%",
                        borderRight: 0,
                      }}
                    >
                      <Text>Received Amount</Text>
                    </View>
                  </View>

                  {/* Table Data */}
                  {mrItems?.map((data, index) => {
                    const dealer = dealers?.find(
                      (drl) => drl?.id === data?.tag_ac_id
                    );

                    return (
                      <View key={index} style={styles.tableRow}>
                        <View style={{ ...styles.tableCell, width: "8%" }}>
                          <Text>{index + 1}</Text>
                        </View>
                        <View
                          style={{
                            ...styles.tableCell,
                            width: "11%",
                            textAlign: "left",
                          }}
                        >
                          <Text>{data?.invoice_id}</Text>
                        </View>
                        <View
                          style={{
                            ...styles.tableCell,
                            width: "15%",
                            textAlign: "left",
                          }}
                        >
                          <Text> {formatDate(data?.trDate)}</Text>
                        </View>
                        <View
                          style={{
                            ...styles.tableCell,
                            width: "25%",
                            textAlign: "left",
                          }}
                        >
                          <Text>{dealer?.d_name}</Text>
                        </View>
                        <View
                          style={{
                            ...styles.tableCell,
                            width: "28%",
                            textAlign: "left",
                          }}
                        >
                          <Text>{data?.description}</Text>
                        </View>
                        <View
                          style={{
                            ...styles.tableCell,
                            width: "13%",
                            borderRight: 0,
                          }}
                        >
                          <Text>{data?.credit_amount}</Text>
                        </View>
                      </View>
                    );
                  })}
                  <View style={styles.tableRow}>
                    <View
                      style={{
                        ...styles.tableCell,
                        borderBottom: 0,
                        borderRight: 0,
                        width: "100% ",
                        textAlign: "right",
                      }}
                    >
                      <Text style={{ fontSize: "12px" }}>
                        Total: {subTotal}
                      </Text>
                    </View>
                  </View>
                </View>

                <View style={styles.author} fixed>
                  <Text style={styles.authorText}>Received By:</Text>
                  <Text>Prepared By: {user?.name}</Text>
                  <Text style={styles.authorText}>Authorised Signature</Text>
                </View>

                {/* Page Number */}
                <View style={styles.pageNumber} fixed>
                  <Text
                    render={({ pageNumber, totalPages }) =>
                      `page ${pageNumber} of ${totalPages}`
                    }
                  />
                </View>

                {/* Footer */}
                <View style={styles.footer} fixed>
                  {visible && (
                    <View style={styles.footerAddr}>
                      <Text>
                        15/A Zigatola, Hafizullah Green Tower, Flat # C1,
                        Dhanmondi, Dhaka - 1209
                      </Text>
                      <Text>
                        Cell: 01711-071102, 01977-071102, 01778-874364, E-mail:
                        jahangirjohura@gmail.com / Web: www.johurabd.com
                      </Text>
                    </View>
                  )}
                  {visible && <Text style={styles.footerBgc}></Text>}
                </View>
              </Page>
            </Document>
          </PDFViewer>
        </div>
      )}
    </div>
  );
};

export default CollectionReports;
